import axiosClient from "./../services/axios-client";


/**
 * 
 * @param { file object } e 
 * @param { callback function that calls after successfull upload and pass file name in return} callBack 
 * @param { true or false } setUploading 
 * @param { how many bytes uploaded} setProgress 
 */

export const uploadAsset = async (e, callBack, setUploading, setProgress) => {

        setUploading(true);

        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        axiosClient.post(`${process.env.REACT_APP_API_URL}/upload-file`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: event => {
                console.log(event.loaded)
                setProgress(100 * event.loaded / event.total);
            }
        }).then((res) => {
            //console.log(res);
            callBack(res.data.filename);
            setUploading(false);
        })

    }